import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaCity, FaArrowLeft } from "react-icons/fa";
import { getUserDetails } from "../../redux/services/User Services/User.Services";
import { Link } from "react-router-dom";
import UserWiseProductList from "./UserWiseProductList";
import ClintWiseLeadList from "./ClintWiseLeadList";
import Search from "../../common/Search";
import Pagination from "../../common/Pagination";
function ViewUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [products, setProducts] = useState([]);
  const [leads, setLeads] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalProducts, setTotalProducts] = useState(0);
  const formatDateTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).replace(/\//g, "-").replace(",", "");
  };
useEffect(() => {
    fetchUserDetails();
}, [id, page, limit]);
  const fetchUserDetails = async () => {
    try {
      setLoading(true);
      const payload = {
        id,
        // search,
        page,
        per_page: limit,
      };
      const response = await getUserDetails(payload);
      if (response.success) {
        setUser(response.data);
        setProducts(response.products || []);
        setLeads(response.leads || []);
        setTotalPages(response.pagination.last_page);
        setTotalProducts(response.pagination.total);
      }
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };
  const filteredProducts = products?.filter((item) => {
    const searchText = search.toLowerCase().trim();

    if (!searchText) return true;

    return (
        item?.name?.toLowerCase().includes(searchText) ||
        item?.product_name?.toLowerCase().includes(searchText) ||
        item?.title?.toLowerCase().includes(searchText) ||
        String(item?.id || "").includes(searchText)
    );
});

const filteredLeads = leads?.filter((item) => {
    const searchText = search.toLowerCase().trim();

    if (!searchText) return true;

    return (
        item?.lead?.name?.toLowerCase().includes(searchText) ||
        item?.lead?.mobile?.toLowerCase().includes(searchText) ||
        String(item?.lead?.id || "").includes(searchText)
    );
});
  // useEffect(() => {
  //   if (id) {
  //     fetchUserDetails();
  //   }
  // }, [id]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3">Loading Vendor Details...</h5>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="text-center py-5">
        <h5>No user Found</h5>
        <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }
  const isActive = user?.status === "active" || user?.status === 1;
  return (
    <>
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Vendor Details</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Vendor  Details</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </div>
      <div className="main_page">
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">Name</label>
              <input type="text" disabled className="form-control" value={user?.name || "-"} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">Mobile</label>
              <input type="text" disabled className="form-control" value={user?.mobile || "-"} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">Category</label>
              <input type="text"
                disabled
                className="form-control"
                value={user?.user_category?.category?.name || "-"}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">SubCategory</label>
              <input type="text" disabled className="form-control" value={user?.user_category?.subcategory?.name || "-"} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">Business</label>
              <input type="text" disabled className="form-control" value={user?.business_name} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">Created At</label>
              <input type="text" disabled className="form-control" value={user?.created_at ? formatDateTime(user.created_at) : "-"} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="fw-bold text-muted">Updated At</label>
              <input type="text" disabled className="form-control" value={user?.updated_at ? formatDateTime(user.updated_at) : "-"} />

            </div>
          </div>

{products?.length > 0 && (
    <>
        <div className="d-flex justify-content-between align-items-center mt-4">
            <h4 className="mb-0">Product List</h4>

            <Search
                search={search}
                placeholder="Search Product..."
                onSearch={(value) => {
                    setSearch(value);
                    setPage(1);
                }}
            />
        </div>

        <UserWiseProductList
              products={filteredProducts}
            page={page}
            limit={limit}
        />
    </>
)}

{leads?.length > 0 && (
    <>
        <div className="d-flex justify-content-between align-items-center mt-4">
            <h4 className="mb-0">Lead List</h4>

            <Search
                search={search}
                placeholder="Search Lead..."
                onSearch={(value) => {
                    setSearch(value);
                    setPage(1);
                }}
            />

        </div>

        <ClintWiseLeadList
           lead={filteredLeads}
            page={page}
            limit={limit}
        />
    </>
)}
          {totalPages > 1 && (
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={(newPage) => setPage(newPage)}
              />
            </div>
          )}


        </div>
      </div>
    </>
  );
}

export default ViewUser;